export default {"src":"/_next/static/media/opportunity-pie-graph.2a170142.svg","height":501,"width":744,"blurWidth":0,"blurHeight":0};